import {
  CURRENTLY_OPERATING_COUNTRIES,
  getCountryFlag,
  getCountryName,
  type CurrentlyOperatingCountry,
  CurrentlyOperatingCountrySchema,
} from "@jeff/common-resources";
import { FormControl } from "./form-control";
import { FormHelperText } from "./form-helper-text";
import { InputLabel } from "./input-label";
import { MenuItem } from "./menu-item";
import { Select, type SelectChangeEvent } from "./select";

const SORTED_COUNTRIES = [...CURRENTLY_OPERATING_COUNTRIES].sort((a, b) =>
  getCountryName(a).localeCompare(getCountryName(b)),
);

type SelectCountryProps = {
  countryCode: CurrentlyOperatingCountry | null;
  onChange: (countryCode: CurrentlyOperatingCountry | null) => void;
  disabled?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  required?: boolean;
};

export function SelectCountry({
  countryCode,
  onChange,
  disabled = false,
  error = false,
  fullWidth = true,
  helperText,
  required = false,
}: SelectCountryProps) {
  return (
    <FormControl fullWidth={fullWidth} error={error} required={required}>
      <InputLabel id="country-code-label">Country</InputLabel>
      <Select
        labelId="country-code-label"
        label="Country"
        value={countryCode ?? ""}
        disabled={disabled}
        onChange={(
          event: SelectChangeEvent<CurrentlyOperatingCountry | string>,
        ) => {
          const parsedCountry = CurrentlyOperatingCountrySchema.safeParse(
            event.target.value,
          );
          onChange(parsedCountry.success ? parsedCountry.data : null);
        }}
      >
        <MenuItem value="">Select a country</MenuItem>
        {SORTED_COUNTRIES.map((country) => (
          <MenuItem key={country} value={country}>
            {getCountryFlag(country)} {getCountryName(country)}
          </MenuItem>
        ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
